export default "__VITE_ASSET__beb82528__"